import { forwardRef, useId } from 'react';

import type { ICheckboxProps } from '../../../interfaces/inputs';
import './CustomCheckbox.scss';

export const CustomCheckbox = forwardRef<HTMLInputElement, ICheckboxProps>(
  ({ id, label, containerClassName, className, disabled, ...inputProps }, ref) => {
    const generatedId = useId();
    const checkboxId = id ?? generatedId;

    const rootClassName = ['custom-checkbox', disabled ? 'custom-checkbox--disabled' : '', containerClassName ?? '']
      .filter(Boolean)
      .join(' ');

    return (
      <label className={rootClassName} htmlFor={checkboxId}>
        <input
          ref={ref}
          id={checkboxId}
          type="checkbox"
          className={['custom-checkbox__input', className ?? ''].filter(Boolean).join(' ')}
          disabled={disabled}
          {...inputProps}
        />
        <span className="custom-checkbox__box" aria-hidden="true" />
        {label && <span className="custom-checkbox__label">{label}</span>}
      </label>
    );
  }
);

CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;
